<template>
  <div style="flex: 1; padding: 20px">
    <el-row>
      <h2 style="float: left; margin-left: 15px">AI Model Detail</h2>
      <h3 v-if="modelDetail" style="float: left; margin-left: 15px">
        {{ modelDetail._id }}
        <el-tag>{{ modelDetail.status }}</el-tag>
      </h3>
    </el-row>
    <el-row>
      <el-select
        v-model="modelDetail.published"
        style="float: right"
        @change="savePublishStatus"
      >
        <el-option label="Published" :value="true"></el-option>
        <el-option label="Not published" :value="false"></el-option>
      </el-select>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-card
          header="error"
          style="padding:10px; word-break"
          v-if="modelDetail.status == 'error'"
        >
          {{ JSON.stringify(modelDetail.errorReason, null, 4) }}
        </el-card>
      </el-col>
      <el-col
        :span="5"
        style="padding-right: 10px"
        v-if="modelDetail.status == 'completed'"
      >
        <el-card
          v-if="modelDetail.classes"
          blcoked="disabled"
          header="Class Mapping"
          shadow="hover"
          style="padding-bottom: 10px"
        >
          <el-form inline label-width="60px">
            <el-form-item
              :label="c"
              v-for="c in Object.keys(modelDetail.classes)"
              :key="c"
            >
              <el-input style="width: 150px" v-model="modelDetail.classes[c]" />
            </el-form-item>
          </el-form>
          <el-button style="float: left" @click="classMappingSave"
            >Save</el-button
          >
          <el-button style="float: right">Reset</el-button>
        </el-card>

        <el-form> </el-form>
      </el-col>
      <el-col :span="19">
        <el-card
          v-loading="predictLoading"
          header="Predict"
          shadow="hover"
          style="margin-bottom: 10px"
        >
          <el-form inline>
            <el-form-item label="MeasurementId">
              <el-input
                :disabled="modelDetail.status != 'completed'"
                v-model="measurementId"
              />
            </el-form-item>
            <el-form-item label="">
              <el-button @click="predictMeasurement">Predict</el-button>
            </el-form-item>
          </el-form>
        </el-card>
        <el-card header="Predictions" shadow="hover">
          <el-row>
            <el-col :span="24" style="text-align: right"> </el-col>
            <el-col>
              <el-table :data="modelDetail.predictions" class="border">
                <el-table-column prop="createdAt" label="Created at" />
                <el-table-column prop="measurement_id" label="Measurement" />
                <el-table-column label="Label">
                  <template slot-scope="scope">
                    {{ modelDetail.classes[`class ${scope.row.label}`] }}
                  </template>
                </el-table-column>
                <el-table-column label="Score">
                  <template slot-scope="scope">
                    {{ scope.row.score }}
                  </template>
                </el-table-column>
                <el-table-column prop="shouldTrain" label="Should Train">
                  <template slot-scope="scope">
                    {{ scope.row.shouldTrain ? "true" : "false" }}
                  </template>
                </el-table-column>
                <el-table-column prop="hasError" label="HasError ">
                  <template slot-scope="scope">
                    {{ scope.row.hasError ? "true" : "false" }}
                  </template>
                </el-table-column>
                <el-table-column prop="isAnomaly" label="Is Anomaly">
                  <template slot-scope="scope">
                    {{ scope.row.isAnomaly ? "true" : "false" }}
                  </template>
                </el-table-column>
                <el-table-column prop="isAnomaly" label="Is Anomaly">
                  <template slot-scope="scope">
                    <span v-if="scope.row.error">
                      <el-popover
                        placement="left-end"
                        width="500"
                        style="max-height: 300px"
                        trigger="hover"
                      >
                        <p style="max-height: 300px; overflow-y: auto">
                          {{ scope.row.error }}
                        </p>
                        <i
                          class="color-circle"
                          style="background-color: red"
                          slot="reference"
                          >Error</i
                        >
                      </el-popover>
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
import ai_service from "../service/aiModel";
export default {
  name: "AIModel",
  data() {
    return {
      prePrintValue: "",
      query: {
        point: "",
        customer: "",
        page: 1,
        pageSize: 10,
      },
      measurementId: "",

      editId: "",
      showForm: false,
      formLoading: false,
      certs: {},
      showCertsForm: false,
      form: {
        customer: "",
        pointId: "",
        algorithm: "",
        features: "",
        dateRange: "",
      },
      rules: {
        customer: [
          {
            required: true,
            message: "Please select customer",
            trigger: "blur",
          },
        ],

        name: [
          { required: true, message: "Please input name", trigger: "blur" },
        ],
        point: [
          { required: true, message: "Please input point", trigger: "blur" },
        ],
        dateRange: [
          {
            required: true,
            message: "Please select dateRange",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getAIModel(this.$route.params.modelId);
    this.getCustomers();
  },
  computed: {
    ...mapState("aiModel", ["modelDetail", "predictLoading"]),
    ...mapState("partner", ["customers", "partners"]),

    customerSelect() {
      return this.customers.map((x) => {
        return {
          value: x._id,
          label: `${x.name}(${x._id})`,
          key: x._id,
        };
      });
    },
  },
  methods: {
    loadCustomersForCreateAIModel() {
      return this.getCustomers({ partner: this.form.partner });
    },
    async savePublishStatus() {
      this.$confirm("Are you sure?", "Warning", {
        confirmButtonText: "Yes, send",
        cancelButtonText: "No",
        type: "warning",
      }).then(async () => {
        console.log("published",this.modelDetail.published)
        await this.updateAIModelPublishStatus({
          modelId: this.modelDetail._id,
          published: this.modelDetail.published,
        });
        await this.getAIModel(this.modelDetail._id);
      });
    },
    async loadCustomers() {
      this.query.customer = "";
      this.form.customer = "";
      await this.loadCustomersOnly();
      await this.load();
    },
    ...mapActions("aiModel", [
      "getAIModel",
      "predict",
      "saveModelClasses",
      "updateAIModelPublishStatus",
    ]),
    ...mapActions("partner", ["getPartners", "getCustomers"]),
    async downloadModel(row) {
      this.prePrintValue = row;
      this.previewShowForm = true;
      let a = await ai_service.getAIModelSignedUrl(row._id);
      this.downloadUrl(a.url);
    },
    async downloadReport(row) {
      this.prePrintValue = row;
      this.previewShowForm = true;
      let a = await ai_service.getAIReportSignedUrl(row._id);
      this.downloadUrl(a.url);
    },
    downloadUrl(href) {
      window.open(href, "Download");
    },
    load() {
      this.getAIModels(this.query);
    },
    adviseSystemAdmin() {
      this.$message.info("advise to the system admin");
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    classMappingSave() {
      this.saveModelClasses({
        modelId: this.modelDetail._id,
        classes: this.modelDetail.classes,
      });
    },
    CreateAIModel() {
      this.$confirm("Are you sure?", "Warning", {
        confirmButtonText: "Yes, send",
        cancelButtonText: "No",
        type: "warning",
      }).then(() => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.formLoading = true;
            this.createAIModel({
              customer: this.form.customer,
              pointId: this.form.pointId,
              startDate: moment(this.form.dateRange[0]).format(
                "YYYY-MM-DD HH:mm:ss"
              ),
              endDate: moment(this.form.dateRange[1]).format(
                "YYYY-MM-DD HH:mm:ss"
              ),
              algorithm: this.form.algorithm,
              features: this.form.features,
            })
              .finally(() => {
                this.showForm = false;
                this.formLoading = false;
                this.load();
              })
              .catch((e) => {
                this.$message.error(e);
              });
          }
        });
      });
    },
    predictMeasurement() {
      if (this.measurementId) {
        this.predict({
          modelId: this.modelDetail._id,
          measurementId: this.measurementId,
        });
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
abbr {
  max-width: 150px;
  word-break: initial;
}
.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}
.tree-container {
  flex-basis: 20%;
  border: 1.5px solid #e4e7ed;
  margin-right: 10px;
}
.tabs {
  flex-basis: 80%;
  display: flex;
}
</style>